export default __webpack_public_path__ + "static/media/hero-banner-1.2afd9569.png";